import { createContext as s, useContext as e } from "react";
import { ShowColumns as t, ShowRows as n } from "../../types/index.js";
const l = !1, A = !1, a = [], p = [], r = !1, i = !1, m = t.All, D = n.All, o = s({
  autofix: l,
  deferringSchema: i,
  dropFailedRows: A,
  hashedColumns: p,
  mappedColumns: a,
  mapping: r,
  setAutofix: () => {
  },
  setDeferringSchema: () => {
  },
  setDropFailedRows: () => {
  },
  setHashedColumns: () => {
  },
  setMappedColumns: () => {
  },
  setMapping: () => {
  },
  setShowColumns: () => {
  },
  setShowRows: () => {
  },
  showColumns: m,
  showRows: D
}), c = o.Provider, C = () => e(o);
export {
  l as DEFAULT_AUTOFIX,
  i as DEFAULT_DEFERING_SCHEMA,
  A as DEFAULT_DROP_FAILED_ROWS,
  a as DEFAULT_HASHED_COLUMNS,
  p as DEFAULT_MAPPED_COLUMNS,
  r as DEFAULT_MAPPING,
  m as DEFAULT_SHOW_COLUMNS,
  D as DEFAULT_SHOW_ROWS,
  o as OptionsContext,
  c as OptionsProvider,
  C as useOptions
};
//# sourceMappingURL=OptionsContext.js.map
